<template>
  <div>
    <deposit-project-list :operateColumns="operateColumns" :canRefresh="true" ref="depositList"></deposit-project-list>
  </div>
</template>

<script>
import DepositProjectList from '@/components/depositProjectList'
import DepositDetail from './depositDetail'

export default {
  name: 'depositProject',
  components: {
    DepositProjectList,
    DepositDetail
  },
  data() {
    return {
      operateColumns: [
        {
          title: '收取信息',
          render: (h, params) => {
            return (
              <DepositDetail marginDetail={params.row.clMargin} projectData={params.row.clProjectDb} {...{on: {'refreshData': this.refreshData}}}></DepositDetail>
            )
          }
        }
      ]
    }
  },
  methods: {
    refreshData() {
      this.$refs.depositList.updateMarginData()
    }
  }
}
</script>
